import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as messageAction from "../../../store/message/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { get, post } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import { DatePicker } from "antd";
import DieselFuel from "./tab/DieselFuel"
import Flatpickr from "react-flatpickr";
import Loading from "../../../components/Custom/Loading";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import classnames from "classnames";
import moment from "moment";
import { withTranslation } from "react-i18next";

// import {
//   listDataDieselFueloilData,
//   columnsDieselFueloilData,
// } from "./data/DieselFueloilData";

//i18n
function Diesel_FuelOilData(props) {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");
  // const searchObj = {
  //   GAS_MONTHYEAR: moment(new Date()).format(
  //     "YYYY-MM-01"
  //   )
  // };
  const createObj = { PID: "", ALIAS_NAME: "" };


  const [dateSelected, setDateSelected] = useState(moment().add(-1,'day').toDate());
  // 2021,9,1

  // const [searchModel, setSearchModel] = useState(searchObj);
  const [tempSearch, setTempSearch] = useState({
    GAS_MONTHYEAR: new Date(),
  });

  const [userActionType, setUserActionType] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];

  function disabledDate(current) {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
  }

  //headerColumn

 

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  // const rowStyleFontWhite = (row, rowIndex) => {
  //   const style = {};
  //   // style.fontWeight = 'bold';
  //   style.color = 'white';

  //   return style;
  // };

  //headerColumn
  const columnsDieselFueloilData = [
    {
      dataField: "Dummy",
      text: "Date",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7e8eda",
        fontSize: "10px",
        width: "1%"
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "BPK1_DATA_FUEL",
      text: "BPK-โรงไฟฟ้า",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#6478D7",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "BPK2_DATA_FUEL",
      text: "BPK-ท่าเรือ",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#6478D7",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "KA_DATA",
      text: "KA",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#6478D7",
        fontSize: "10px",
        width: "5%",
      },
    },

    {
      dataField: "RBT_DATA",
      text: "RB-T",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#6478D7",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "BPK1_DATA_DIESEL",
      text: "BPK-โรงไฟฟ้า",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "BPK2_DATA_DIESEL",
      text: "BPK-ท่าเรือ",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "SBS4_DATA",
      text: "SB-S4",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "NPO_DATA",
      text: "NPO",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "CHN_DATA",
      text: "CHN",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "KN52_DATA",
      text: "KN-52",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "RBC_DATA",
      text: "RB-C",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "RPCL_DATA",
      text: "RPCL",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GPSC_DATA",
      text: "GPSC",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GLOW_DATA",
      text: "GLOW",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "EPEC_DATA",
      text: "EPEC",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GPG_DATA",
      text: "GPG",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GNS_DATA",
      text: "GNS",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GUT_DATA",
      text: "GUT",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GSRC_DATA",
      text: "GSRC",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "5%",
      },
    },
    {
      dataField: "GPD_DATA",
      text: "GPD",
      headerAlign: "center",
      editable: true,
      align: "right",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "10px",
        width: "4%",
      },
    },
    // {
    //   dataField: "action",
    //   formatter: ButtonAction,
    //   text: "Action",
    //   headerAlign: "center",
    //   editable: false,
    //   align: "center",
    //   isDummyField: true,

    // }
  ];


  //Function CURL 





  useEffect(function () {
    
  }, []);

const TabBar = useMemo(() => {
  return (
 
                          <TabPane tabId="1">
                        
                            <DieselFuel dateSelected={dateSelected}/>
                          </TabPane>
                         
                 
  )
}, [dateSelected])

  

 

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Diesel & Fuel Oil Data")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Diesel & Fuel Oil Data
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                          <div className=" d-flex align-items-center justify-content-end">
                              <h5> Data Month :      </h5>
                              <DatePicker
                                style={{ width: 200 ,marginLeft:20}}
                                defaultValue={moment(dateSelected)}
                                format={"MMMM YYYY"}
                                onChange={(date, dateString) => {
                                  if (date != null) {
                                    setDateSelected(date.toDate());
                                  }
                                }}
                                picker="month"
                                disabledDate={disabledDate}
                              />
                            </div>
                            {/* <Col
                              sm={9}
                              className=" d-flex align-items-center justify-content-end"
                            >
                              <h5> Data Monthly :</h5>
                            </Col>
                            <Col
                              sm={3}
                              className="d-flex align-items-center justify-content-start"
                            >
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                onChange={value => setDateSelected(...value)}
                                value={dateSelected}
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                  maxDate: new Date(),
                                }}
                              />
                            </Col> */}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Diesel & Fuel Oil Data
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                      <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                        {TabBar}
                        </TabContent>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

      {/*Loading */}
      {/* <Loading show={isLoading} /> */}
      {/*Loading */}

      {/* comfirmDialog */}
      {/* <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      /> */}

      {/*end : PageAdd */}
    </React.Fragment>
  );
}

Diesel_FuelOilData.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Diesel_FuelOilData }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Diesel_FuelOilData));

